import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getToken } from "../utils/auth";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import DataTable from "react-data-table-component";
import html2pdf from "html2pdf.js";

const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";

export default function Orders() {
  const challanRef = useRef(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [trackingOrder, setTrackingOrder] = useState(null);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const userDataStr = localStorage.getItem("userData");
    if (userDataStr) {
      setUserData(JSON.parse(userDataStr));
    }
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${API_URL}/order/webapp-orders`, {});
        setOrders(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const getStatusBadge = (status) => {
    const statusConfig = {
      pending: { class: "bg-warning", text: "Pending" },
      confirmed: { class: "bg-info", text: "Confirmed" },
      assigned: { class: "bg-success", text: "Assigned" },
      out_for_delivery: { class: "bg-info", text: "Out for Delivery" },
      delivered: { class: "bg-success", text: "Delivered" },
      return_pending: { class: "bg-warning", text: "Return Pending" },
      out_for_return: { class: "bg-info", text: "Out for Return" },
      returned: { class: "bg-success", text: "Returned" },
      cancelled: { class: "bg-danger", text: "Cancelled" },
    };

    const config = statusConfig[status] || {
      class: "bg-secondary",
      text: status,
    };
    return (
      <span className={`badge ${config.class} text-white fw-bold`}>
        {config.text}
      </span>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleOrderClick = (order) => {
    console.log("order_data", order);
    setSelectedOrder(order);
    setShowOrderModal(true);
  };

  const closeModal = () => {
    setShowOrderModal(false);
    setSelectedOrder(null);
  };

  const handleTrackOrder = (order) => {
    setTrackingOrder(order);
    setShowTrackingModal(true);
  };

  const closeTrackingModal = () => {
    setShowTrackingModal(false);
    setTrackingOrder(null);
  };

  const item = (selectedOrder?.items && selectedOrder?.items[0]) || {};

  const printChallen = () => {
    // 1. Re-access the item object inside the function (good practice)
    const item = (selectedOrder?.items && selectedOrder?.items[0]) || {};
    // 2. Get the HTML element
    const challan = document.getElementById("standby-challan");
    if (!challan) {
      console.error("Challan element (standby-challan1) not found!");
      return;
    }
    // 3. Define options
    const opt = {
      margin: 10,
      // Ensure item.name exists before calling replace
      filename: `standby_challan_${
        item.name ? item.name.replace(/\s+/g, "_") : "product"
      }.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true }, // Added useCORS for external images
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    // 4. Generate and Save PDF
    html2pdf().from(challan).set(opt).save();
  };

  const columns = [
    {
      name: "Sr No",
      selector: (row, index) => index + 1,
      width: "80px",
      sortable: true,
    },
    {
      name: "Order #",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Customer",
      selector: (row) => row.shipping_address?.doctorName || "N/A",
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => getStatusBadge(row.status),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => formatDate(row.created_at),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => handleOrderClick(row)}
        >
          View Details
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#39465c",
        color: "white",
        fontWeight: "bold",
        fontSize: "15px",
      },
    },
    cells: {
      style: {
        padding: "8px",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        minHeight: "45px",
        "&:hover": {
          backgroundColor: "#f1f1f1",
        },
      },
    },
  };
  if (userData && userData.role === "deliveryman") {
    return (
      <>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="page-title-box">
                <h4 className="page-title">My Delivery & Return History</h4>
              </div>
              <div className="card">
                <div className="card-body">
                  {orders.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="mdi mdi-package-variant-closed mdi-48px text-muted"></i>
                      <h5 className="mt-3">No Delivery/Return History</h5>
                      <p className="text-muted">
                        You have not completed any deliveries or returns yet.
                      </p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <DataTable
                        columns={columns}
                        data={orders}
                        highlightOnHover
                        striped
                        responsive
                        pagination
                        customStyles={customStyles}
                        defaultSortFieldId="date" // sort by Date column
                        defaultSortAsc={false}
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* Order Detail Modal (reuse existing modal logic) */}
              {showOrderModal &&
                selectedOrder &&
                (() => {
                  const item = selectedOrder.items[0] || {};
                  return (
                    <div
                      className="modal fade show"
                      style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)",
                      }}
                    >
                      <div className="modal-dialog modal-lg">
                        <div
                          className="modal-content"
                          style={{ borderRadius: "8px", border: "none" }}
                        >
                          <div
                            className="modal-header bg-white"
                            style={{
                              borderBottom: "1px solid #eee",
                              padding: "1rem 1.5rem",
                            }}
                          >
                            <h5 className="modal-title">
                              Order Details -{" "}
                              <span className="text-primary">
                                {selectedOrder.id}
                              </span>
                            </h5>
                            <button
                              type="button"
                              onClick={closeModal}
                              className="order-btn"
                              style={{ opacity: 0.5 }}
                              aria-label="Close"
                            >
                              {" "}
                              ×
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            style={{ padding: "1.5rem" }}
                          >
                            <div className="row">
                              <div className="col-md-6">
                                <div className="card border-0 shadow-sm mb-4">
                                  <div className="card-body">
                                    <h6 className="card-title text-dark mb-4">
                                      Product Information
                                    </h6>
                                    <div className="text-center mb-4">
                                      <img
                                        src={
                                          item.image
                                            ? item.image.startsWith("http")
                                              ? item.image
                                              : `https://sunrise-backend.sunrisemeditechsystems.com/${item.image.replace(
                                                  /^\/+/,
                                                  "",
                                                )}`
                                            : "/no-image.png"
                                        }
                                        alt={item.name || ""}
                                        className="img-fluid rounded"
                                        style={{
                                          maxHeight: "200px",
                                          objectFit: "contain",
                                          backgroundColor: "#f8f9fa",
                                          padding: "10px",
                                        }}
                                      />
                                    </div>
                                    <div className="info-grid">
                                      <div className="info-item">
                                        <span className="text-muted">
                                          Product:
                                        </span>
                                        <span className="fw-medium">
                                          {item.name}
                                        </span>
                                      </div>
                                      <div className="info-item">
                                        <span className="text-muted">
                                          Quantity:
                                        </span>
                                        <span className="fw-medium">
                                          {item.quantity}
                                        </span>
                                      </div>
                                      <div className="info-item">
                                        <span className="text-muted">
                                          Type:
                                        </span>
                                        <span className="badge bg-soft-primary text-primary">
                                          {item.buyOrRent === "buy"
                                            ? "Buy"
                                            : item.buyOrRent === "stand_by"
                                              ? "Stand By"
                                              : item.buyOrRent === "demo"
                                                ? "Demo"
                                                : "Buy"}
                                        </span>
                                      </div>
                                      <div className="info-item">
                                        <span className="text-muted">
                                          Unit Price:
                                        </span>
                                        <span className="fw-medium">
                                          ₹{item.price}
                                        </span>
                                      </div>
                                      <div className="info-item border-0">
                                        <span className="text-muted">
                                          Total Amount:
                                        </span>
                                        <span className="fw-medium text-success">
                                          ₹{item.price * item.quantity}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="card border-0 shadow-sm mb-4">
                                  <div className="card-body">
                                    <h6 className="card-title text-dark mb-4">
                                      Hospital Information
                                    </h6>
                                    <div className="info-grid">
                                      <div className="info-item">
                                        <span className="text-muted">
                                          Hospital:
                                        </span>
                                        <span className="fw-medium">
                                          {selectedOrder.shipping_address
                                            ?.hospitalName || ""}
                                        </span>
                                      </div>
                                      <div className="info-item">
                                        <span className="text-muted">
                                          Doctor:
                                        </span>
                                        <span className="fw-medium">
                                          {selectedOrder.shipping_address
                                            ?.doctorName || ""}
                                        </span>
                                      </div>
                                      <div className="info-item">
                                        <span className="text-muted">
                                          Phone:
                                        </span>
                                        <span className="fw-medium">
                                          {selectedOrder.shipping_address
                                            ?.doctorPhone || ""}
                                        </span>
                                      </div>
                                      <div className="info-item border-0">
                                        <span className="text-muted">
                                          Address:
                                        </span>
                                        <span className="fw-medium">
                                          {selectedOrder.shipping_address
                                            ?.hospitalAddress || ""}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Add this CSS to your stylesheet */}
                            <style>
                              {`
                            .info-grid {
                              display: grid;
                              gap: 1rem;
                            }
                            .info-item {
                              display: grid;
                              grid-template-columns: 120px 1fr;
                              padding-bottom: 0.75rem;
                              border-bottom: 1px solid #eee;
                              align-items: center;
                            }
                            .info-item.border-0 {
                              border-bottom: none;
                              padding-bottom: 0;
                            }
                            .bg-soft-primary {
                              background-color: rgba(85, 110, 230, 0.1) !important;
                            }
                          `}
                            </style>

                            <div className="row mt-3">
                              <div className="col-12">
                                <h6>Order Timeline</h6>
                                <div className="timeline">
                                  <div className="timeline-item">
                                    <div className="timeline-marker bg-success"></div>
                                    <div className="timeline-content">
                                      <h6>Order Placed</h6>
                                      <p className="text-muted">
                                        {formatDate(selectedOrder.created_at)}
                                      </p>
                                    </div>
                                  </div>
                                  {selectedOrder.assignedDate && (
                                    <div className="timeline-item">
                                      <div className="timeline-marker bg-primary"></div>
                                      <div className="timeline-content">
                                        <h6>Assigned to Delivery</h6>
                                        <p className="text-muted">
                                          {formatDate(
                                            selectedOrder.assignedDate,
                                          )}
                                        </p>
                                        {selectedOrder.assigned_deliveryman && (
                                          <p>
                                            <strong>Deliveryman:</strong>{" "}
                                            {selectedOrder.assigned_deliveryman}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {selectedOrder.deliveryDate && (
                                    <div className="timeline-item">
                                      <div className="timeline-marker bg-success"></div>
                                      <div className="timeline-content">
                                        <h6>Delivered</h6>
                                        <p className="text-muted">
                                          {formatDate(
                                            selectedOrder.deliveryDate,
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {selectedOrder.returnDate && (
                                    <div className="timeline-item">
                                      <div className="timeline-marker bg-info"></div>
                                      <div className="timeline-content">
                                        <h6>Returned</h6>
                                        <p className="text-muted">
                                          {formatDate(selectedOrder.returnDate)}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {selectedOrder.delivery_photos && (
                              <div className="row mt-3">
                                <div className="col-12">
                                  <h6>Delivery Photo</h6>
                                  <img
                                    src={`https://sunrise-backend.sunrisemeditechsystems.com${selectedOrder.delivery_photos}`}
                                    alt="Delivery"
                                    className="img-fluid rounded"
                                    style={{ maxHeight: "200px" }}
                                  />
                                </div>
                              </div>
                            )}

                            {selectedOrder.return_photos && (
                              <div className="row mt-3">
                                <div className="col-12">
                                  <h6>Return Photo</h6>
                                  <img
                                    src={`https://sunrise-backend.sunrisemeditechsystems.com${selectedOrder.return_photos}`}
                                    alt="Return"
                                    className="img-fluid rounded"
                                    style={{ maxHeight: "200px" }}
                                  />
                                </div>
                              </div>
                            )}

                            {["out_for_delivery", "out_for_return"].includes(
                              selectedOrder.status,
                            ) &&
                              selectedOrder.delivery_location &&
                              selectedOrder.delivery_location.latitude &&
                              selectedOrder.delivery_location.longitude && (
                                <div className="row mt-3">
                                  <div className="col-12">
                                    <div className="card border-0 shadow-sm">
                                      <div className="card-body">
                                        <h6 className="mb-3">
                                          Delivery Location
                                        </h6>
                                        <div
                                          style={{
                                            height: "400px",
                                            width: "100%",
                                            position: "relative",
                                            overflow: "hidden",
                                            borderRadius: "8px",
                                          }}
                                        >
                                          <MapContainer
                                            center={[
                                              selectedOrder.delivery_location
                                                .latitude,
                                              selectedOrder.delivery_location
                                                .longitude,
                                            ]}
                                            zoom={15}
                                            style={{
                                              height: "100%",
                                              width: "100%",
                                            }}
                                            scrollWheelZoom={true}
                                          >
                                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                            <Marker
                                              position={[
                                                selectedOrder.delivery_location
                                                  .latitude,
                                                selectedOrder.delivery_location
                                                  .longitude,
                                              ]}
                                            >
                                              <Popup>
                                                <div className="p-1">
                                                  <strong>
                                                    {selectedOrder
                                                      .assigned_deliveryman
                                                      ?.name || "Deliveryman"}
                                                    's Location
                                                  </strong>
                                                  <br />
                                                  {selectedOrder
                                                    .delivery_location
                                                    .address || ""}
                                                </div>
                                              </Popup>
                                            </Marker>
                                          </MapContainer>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
            </div>
          </div>
        </div>
      </>
    );
  }
  const toggleConfirm = async (e, row) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${API_URL}/orders/toggle-confirm/${row.id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // Update only clicked row in table
      setOrders((prevOrders) =>
        prevOrders.map((order) => {
          if (order.id === row.id) {
            return { ...order, confirmed: res.data.status };
          }
          return order;
        }),
      );

      Swal.fire("Success", "Order status updated!", "success");
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to update order status", "error");
    }
  };

  const orderColumns = [
    {
      name: "Order #",
      selector: (row) => row.orderId || row.id,
      cell: (row) => (
        <div className="order-id">
          Order ID: <strong>{row.id}</strong>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Product",
      selector: (row) => row.items?.[0]?.name || "", // 👈 this enables sorting
      cell: (row) => {
        const item = row.items[0] || {};
        return (
          <div className="d-flex align-items-center">
            <img
              src={
                item.image
                  ? item.image.startsWith("http")
                    ? item.image
                    : `https://sunrise-backend.sunrisemeditechsystems.com/${item.image.replace(
                        /^\/+/,
                        "",
                      )}`
                  : "/no-image.png"
              }
              alt={item.name || ""}
              className="rounded me-2"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                marginRight: "5px",
              }}
            />
            <div>
              <h6 className="mb-0">{item.name}</h6>
              <small className="text-muted">Qty: {item.quantity}</small>
            </div>
          </div>
        );
      },
      width: "500px",
      sortable: true, // 👈 now sorting works by product name
    },
    {
      name: "Type",
      cell: (row) => {
        const item = row.items[0] || {};
        return (
          <span
            className={`badge ${
              item.buyOrRent === "buy"
                ? "bg-success"
                : item.buyOrRent === "stand_by"
                  ? "bg-info"
                  : item.buyOrRent === "demo"
                    ? "bg-warning"
                    : "bg-success"
            }
            }`}
          >
            {item.buyOrRent === "buy"
              ? "Buy"
              : item.buyOrRent === "stand_by"
                ? "Stand By"
                : item.buyOrRent === "demo"
                  ? "Demo"
                  : "Buy"}
          </span>
        );
      },
      width: "300px",
    },
    {
      name: "Date",
      selector: (row) => formatDate(row.created_at),
      sortable: true,
      width: "300px",
    },
    {
      name: "Action",
      cell: (row, index) => (
        <div className="d-flex gap-8">
          <div className="d-flex gap-8">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleOrderClick(row)}
            >
              View Details
            </button>
            {["out_for_delivery", "out_for_return"].includes(row.status) && (
              <button
                className="btn btn-sm btn-info text-white"
                onClick={() => handleTrackOrder(row)}
              >
                Track Order
              </button>
            )}
          </div>
          {
            // userData && (
            <button
              className={`btn btn-sm ${
                row.confirmed ? "btn-success" : "btn-warning"
              }`}
              onClick={(e) => toggleConfirm(e, row)}
            >
              {row.confirmed ? "confirmed" : "pending"}
            </button>
            // )
            // )
            //  <button
            //       className="btn btn-sm btn-success ms-2"
            //       onClick={() => handleConfirmProductOrder(row.id)}
            //     >
            //       Confirm
            //     </button>
            // !row.assigned_deliveryman && (
            //   <div style={{ marginTop: 8 }}>
            //     <select
            //       value={selectedDeliveryman[row.id] || ""}
            //       onChange={(e) =>
            //         setSelectedDeliveryman({
            //           ...selectedDeliveryman,
            //           [row.id]: e.target.value,
            //         })
            //       }
            //     >
            //       <option value="">Select Deliveryman</option>
            //       {deliverymen.map((dm) => (
            //         <option key={dm.id} value={dm.id}>
            //           {dm.username}
            //         </option>
            //       ))}
            //     </select>
            //     <button
            //       className="btn btn-sm btn-success ms-2"
            //       disabled={!selectedDeliveryman[row.id]}
            //       onClick={() => assignDeliveryman(row.id)}
            //     >
            //       Assign
            //     </button>
            //   </div>
            // )
          }
        </div>
      ),
      width: "250px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  if (loading) {
    return (
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div style={{ display: "none" }}>
        <div id="standby-challan">
          <div>
            <h2 style={{ textAlign: "center" }}>Stand-By Product Challan</h2>
            <hr />
            {/* <p>
              <b>Product Image:</b>&nbsp;&nbsp;
              <img
                src={
                  item.image
                    ? item.image
                      ? item.image
                      : `https://sunrise-backend.sunrisemeditechsystems.com/${item.image.replace(
                          /^\/+/,
                          ""
                        )}`
                    : "/no-image.png"
                }
                alt="product"
                style={{ width: "120px", height: "120px", objectFit: "cover" }}
              />
            </p> */}
            <p>
              <b>Hospital Name:</b>{" "}
              {selectedOrder?.shipping_address?.hospitalName || ""}
            </p>
            <p>
              <b>Doctor Name:</b>{" "}
              {selectedOrder?.shipping_address?.doctorName || ""}
            </p>
            <p>
              <b>Doctor Phone:</b>{" "}
              {selectedOrder?.shipping_address?.doctorPhone || ""}
            </p>
            <p>
              <b>Hospital Address:</b>{" "}
              {selectedOrder?.shipping_address?.hospitalAddress || ""}
            </p>
            <p>
              <b>Receiver Name:</b>{" "}
              {selectedOrder?.shipping_address?.receiverName || ""}
            </p>
            <p>
              <b>Receiver Phone:</b>{" "}
              {selectedOrder?.shipping_address?.receiverPhone || ""}
            </p>
            <p>
              <b>Product Type:</b>{" "}
              {item.buyOrRent === "buy"
                ? "Buy"
                : item.buyOrRent === "stand_by"
                  ? "Stand By"
                  : item.buyOrRent === "demo"
                    ? "Demo"
                    : "Buy"}
            </p>
            {/* <p>
              <b>Repair Product Image:</b>&nbsp;&nbsp;
              <img
                src={
                  selectedOrder?.photo
                    ? selectedOrder.photo
                      ? selectedOrder.photo
                      : `https://sunrise-backend.sunrisemeditechsystems.com/${selectedOrder.photo.replace(
                          /^\/+/,
                          ""
                        )}`
                    : "/no-image.png"
                }
                alt="repair"
                style={{ width: "140px", height: "140px", objectFit: "cover" }}
                crossOrigin="anonymous"
              />
            </p> */}
            <p>
              <b>Product:</b> {item.name}
            </p>
            <p>
              <b>Quantity:</b> {item.quantity}
            </p>
            <p>
              <b>Start Date:</b> {item.startDate}
            </p>
            <p>
              <b>End Date:</b> {item.endDate}
            </p>
            <p>
              <b>Notes:</b> {selectedOrder?.notes}
            </p>
            <hr />
            <div style={{ marginTop: "40px", textAlign: "right" }}>
              <p>Authorized Signature: _____________________</p>
            </div>
          </div>
        </div>
      </div>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            {/* Page Title */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item active">My Orders</li>
                    </ol>
                  </div>
                  <h4 className="page-title">
                    {userData && userData.isStaff ? "All Orders" : "My Orders"}
                    {userData && userData.isStaff && (
                      <span className="badge bg-info ms-2">
                        {userData.role.charAt(0).toUpperCase() +
                          userData.role.slice(1)}{" "}
                        View
                      </span>
                    )}
                  </h4>
                  {userData && userData.isStaff && (
                    <p className="text-muted">
                      {userData.role === "admin" &&
                        "You can view and manage all orders from all sources."}
                      {userData.role === "receptionist" &&
                        "You can view and manage customer orders."}
                      {userData.role === "deliveryman" &&
                        "You can view orders assigned for delivery."}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Orders List */}
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    {orders.length === 0 ? (
                      <div className="text-center py-5">
                        <i className="mdi mdi-package-variant-closed mdi-48px text-muted"></i>
                        <h5 className="mt-3">No Orders Found</h5>
                        <p className="text-muted">
                          You haven't placed any orders yet.
                        </p>
                        <Link to="/shop" className="btn btn-primary">
                          Browse Products
                        </Link>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <DataTable
                          columns={orderColumns}
                          data={orders}
                          highlightOnHover
                          striped
                          responsive
                          pagination
                          customStyles={customStyles}
                          defaultSortFieldId="date" // sort by Date column
                          defaultSortAsc={false}
                        />
                        {/* <table className="table table-centered table-hover mb-0">
                        <thead>
                          <tr>
                            <th>Order #</th>
                            <th>Product</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders.map((order) => {
                            const item = order.items[0] || {};
                            return (
                              <tr key={order._id}>
                                <td>
                                  <div className="order-id">
                                    Order ID:{" "}
                                    <strong>
                                      {order.orderId || order._id.slice(-6).toUpperCase()}
                                    </strong>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={
                                        item.image
                                          ? item.image.startsWith('http')
                                            ? item.image
                                            : `https://sunrise-backend.sunrisemeditechsystems.com/${item.image.replace(/^\/+/, '')}`
                                          : "/no-image.png"
                                      }
                                      alt={item.name || ""}
                                      className="rounded me-2"
                                      style={{ width: "40px", height: "40px", objectFit: "cover" }}
                                    />
                                    <div>
                                      <h6 className="mb-0">{item.name}</h6>
                                      <small className="text-muted">
                                        Qty: {item.quantity}
                                      </small>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <span className={`badge ${item.buyOrRent === 'buy' ? 'bg-success' : 'bg-info'}`}>
                                    {item.buyOrRent === 'buy' ? 'Buy' : 'Rent'}
                                  </span>
                                </td>
                                <td>
                                  <strong>
                                    ₹{order.totalAmount !== undefined ? order.totalAmount : (item.price * item.quantity)}
                                  </strong>
                                </td>
                                <td>
                                  {getStatusBadge(order.status)}
                                </td>
                                <td>
                                  {formatDate(order.createdAt)}
                                </td>
                                <td>
                                  <div className="d-flex gap-1">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => handleOrderClick(order)}
                                    >
                                      View Details
                                    </button>
                                    {['out_for_delivery', 'out_for_return'].includes(order.status) && (
                                      <button
                                        className="btn btn-sm btn-info text-white"
                                        onClick={() => handleTrackOrder(order)}
                                      >
                                        Track Order
                                      </button>
                                    )}
                                  </div>
                                  {userData && (userData.role === 'admin' || userData.role === 'receptionist') &&
                                    order.status === 'confirmed' && !order.assignedDeliveryman && (
                                      <div style={{ marginTop: 8 }}>
                                        <select
                                          value={selectedDeliveryman[order._id] || ""}
                                          onChange={e =>
                                            setSelectedDeliveryman({ ...selectedDeliveryman, [order._id]: e.target.value })
                                          }
                                        >
                                          <option value="">Select Deliveryman</option>
                                          {deliverymen.map(dm => (
                                            <option key={dm._id} value={dm._id}>{dm.username}</option>
                                          ))}
                                        </select>
                                        <button
                                          className="btn btn-sm btn-success ms-2"
                                          disabled={!selectedDeliveryman[order._id]}
                                          onClick={() => assignDeliveryman(order._id)}
                                        >
                                          Assign
                                        </button>
                                      </div>
                                    )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Order Detail Modal */}
            {showOrderModal &&
              selectedOrder &&
              (() => {
                const item = selectedOrder.items[0] || {};
                return (
                  <div
                    className="modal fade show"
                    style={{
                      display: "block",
                      backgroundColor: "rgba(0,0,0,0.5)",
                    }}
                  >
                    <div className="modal-dialog modal-lg">
                      <div
                        className="modal-content"
                        style={{ borderRadius: "8px", border: "none" }}
                      >
                        <div
                          className="modal-header bg-white"
                          style={{
                            borderBottom: "1px solid #eee",
                            padding: "1rem 1.5rem",
                          }}
                        >
                          <h5 className="modal-title">
                            Order Details -{" "}
                            <span className="text-primary">
                              {selectedOrder.id}
                            </span>
                          </h5>
                          <button
                            type="button"
                            onClick={closeModal}
                            className="order-btn"
                            style={{ opacity: 0.5 }}
                            aria-label="Close"
                          >
                            {" "}
                            ×
                          </button>
                        </div>
                        <div
                          className="modal-body"
                          style={{ padding: "1.5rem" }}
                        >
                          <div className="row">
                            <div className="col-12 col-md-6">
                              <div className="card border-0 shadow-sm mb-4">
                                <div className="card-body">
                                  <h6 className="card-title text-dark mb-4">
                                    Product Information
                                  </h6>
                                  <div className="text-left mb-4">
                                    <img
                                      src={
                                        item.image
                                          ? item.image.startsWith("http")
                                            ? item.image
                                            : `https://sunrise-backend.sunrisemeditechsystems.com/${item.image.replace(
                                                /^\/+/,
                                                "",
                                              )}`
                                          : "/no-image.png"
                                      }
                                      alt={item.name || ""}
                                      className="img-fluid rounded"
                                      style={{
                                        maxHeight: "200px",
                                        objectFit: "contain",
                                        backgroundColor: "#f8f9fa",
                                        padding: "10px",
                                      }}
                                    />
                                  </div>
                                  <div className="info-grid">
                                    <div className="info-item">
                                      <span className="text-muted">
                                        Product:
                                      </span>
                                      <span className="fw-medium">
                                        {item.name}
                                      </span>
                                    </div>
                                    <div className="info-item">
                                      <span className="text-muted">
                                        Quantity:
                                      </span>
                                      <span className="fw-medium">
                                        {item.quantity}
                                      </span>
                                    </div>
                                    <div className="info-item">
                                      <span className="text-muted">Type:</span>
                                      <span className="badge bg-soft-primary text-primary text-left">
                                        {item.buyOrRent === "buy"
                                          ? "Buy"
                                          : item.buyOrRent === "stand_by"
                                            ? "Stand By"
                                            : item.buyOrRent === "demo"
                                              ? "Demo"
                                              : "Buy"}
                                      </span>
                                    </div>
                                    <div className="info-item">
                                      <span className="text-muted">
                                        Unit Price:
                                      </span>
                                      <span className="fw-medium">
                                        ₹{item.price}
                                      </span>
                                    </div>
                                    <div className="info-item border-0">
                                      <span className="text-muted">
                                        Total Amount:
                                      </span>
                                      <span className="fw-medium text-success">
                                        ₹{item.price * item.quantity}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-6">
                              <div className="card border-0 shadow-sm mb-4">
                                <div className="card-body">
                                  <h6 className="card-title text-dark mb-4">
                                    Hospital Information
                                  </h6>
                                  <div className="info-grid">
                                    <div className="info-item">
                                      <span className="text-muted">
                                        Hospital:
                                      </span>
                                      <span className="fw-medium">
                                        {selectedOrder.shipping_address
                                          ?.hospitalName || ""}
                                      </span>
                                    </div>
                                    <div className="info-item">
                                      <span className="text-muted">
                                        Doctor:
                                      </span>
                                      <span className="fw-medium">
                                        {selectedOrder.shipping_address
                                          ?.doctorName || ""}
                                      </span>
                                    </div>
                                    <div className="info-item">
                                      <span className="text-muted">Phone:</span>
                                      <span className="fw-medium">
                                        {selectedOrder.shipping_address
                                          ?.doctorPhone || ""}
                                      </span>
                                    </div>
                                    <div className="info-item border-0">
                                      <span className="text-muted">
                                        Address:
                                      </span>
                                      <span className="fw-medium">
                                        {selectedOrder.shipping_address
                                          ?.hospitalAddress || ""}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                               {item.buyOrRent === "stand_by" && (
                              <div className="card border-0 shadow-sm mb-4">
                                <div className="card-body">
                                  <div className="info-grid">
                                    <div className="info-item">
                                      <p>Repair photo</p>
                                      <img
                                        src={
                                          selectedOrder.photo
                                            ? selectedOrder.photo.startsWith(
                                                "http",
                                              )
                                              ? selectedOrder.photo
                                              : `https://sunrise-backend.sunrisemeditechsystems.com/${selectedOrder.photo.replace(
                                                  /^\/+/,
                                                  "",
                                                )}`
                                            : "/no-image.png"
                                        }
                                        // alt="Delivery"
                                        className="img-fluid rounded"
                                        style={{ maxHeight: "200px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>)}
                            </div>
                          </div>

                          {/* Add this CSS to your stylesheet */}
                          <style>
                            {`
                          .info-grid {
                            display: grid;
                            gap: 1rem;
                          }
                          .info-item {
                            display: grid;
                            grid-template-columns: 120px 1fr;
                            padding-bottom: 0.75rem;
                            border-bottom: 1px solid #eee;
                            align-items: center;
                          }
                          .info-item.border-0 {
                            border-bottom: none;
                            padding-bottom: 0;
                          }
                          .bg-soft-primary {
                            background-color: rgba(85, 110, 230, 0.1) !important;
                          }
                        `}
                          </style>

                          <div className="row mt-3">
                            <div className="col-12">
                              <h6>Order Timeline</h6>
                              <div className="timeline">
                                <div className="timeline-item">
                                  <div className="timeline-marker bg-success"></div>
                                  <div className="timeline-content">
                                    <h6>Order Placed</h6>
                                    <p className="text-muted">
                                      {formatDate(selectedOrder.created_at)}
                                    </p>
                                  </div>
                                </div>
                                {selectedOrder.assignedDate && (
                                  <div className="timeline-item">
                                    <div className="timeline-marker bg-primary"></div>
                                    <div className="timeline-content">
                                      <h6>Assigned to Delivery</h6>
                                      <p className="text-muted">
                                        {formatDate(selectedOrder.assignedDate)}
                                      </p>
                                      {selectedOrder.assigned_deliveryman && (
                                        <p>
                                          <strong>Deliveryman:</strong>{" "}
                                          {selectedOrder.assigned_deliveryman}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {selectedOrder.deliveryDate && (
                                  <div className="timeline-item">
                                    <div className="timeline-marker bg-success"></div>
                                    <div className="timeline-content">
                                      <h6>Delivered</h6>
                                      <p className="text-muted">
                                        {formatDate(selectedOrder.deliveryDate)}
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {selectedOrder.returnDate && (
                                  <div className="timeline-item">
                                    <div className="timeline-marker bg-info"></div>
                                    <div className="timeline-content">
                                      <h6>Returned</h6>
                                      <p className="text-muted">
                                        {formatDate(selectedOrder.returnDate)}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {item.buyOrRent === "stand_by" && (
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={printChallen}
                            >
                              Print Challan
                            </button>
                          )}
                          {selectedOrder.delivery_photos && (
                            <div className="row mt-3">
                              <div className="col-12">
                                <h6>Delivery Photo</h6>
                                <img
                                  src={`https://sunrise-backend.sunrisemeditechsystems.com${selectedOrder.delivery_photos}`}
                                  alt="Delivery"
                                  className="img-fluid rounded"
                                  style={{ maxHeight: "200px" }}
                                />
                              </div>
                            </div>
                          )}

                          {selectedOrder.return_photos && (
                            <div className="row mt-3">
                              <div className="col-12">
                                <h6>Return Photo</h6>
                                <img
                                  src={`https://sunrise-backend.sunrisemeditechsystems.com${selectedOrder.return_photos}`}
                                  alt="Return"
                                  className="img-fluid rounded"
                                  style={{ maxHeight: "200px" }}
                                />
                              </div>
                            </div>
                          )}

                          {["out_for_delivery", "out_for_return"].includes(
                            selectedOrder.status,
                          ) &&
                            selectedOrder.delivery_location &&
                            selectedOrder.delivery_location.latitude &&
                            selectedOrder.delivery_location.longitude && (
                              <div className="row mt-3">
                                <div className="col-12">
                                  <div className="card border-0 shadow-sm">
                                    <div className="card-body">
                                      <h6 className="mb-3">
                                        Delivery Location
                                      </h6>
                                      <div
                                        style={{
                                          height: "400px",
                                          width: "100%",
                                          position: "relative",
                                          overflow: "hidden",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <MapContainer
                                          center={[
                                            selectedOrder.delivery_location
                                              .latitude,
                                            selectedOrder.delivery_location
                                              .longitude,
                                          ]}
                                          zoom={15}
                                          style={{
                                            height: "100%",
                                            width: "100%",
                                          }}
                                          scrollWheelZoom={true}
                                        >
                                          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                          <Marker
                                            position={[
                                              selectedOrder.delivery_location
                                                .latitude,
                                              selectedOrder.delivery_location
                                                .longitude,
                                            ]}
                                          >
                                            <Popup>
                                              <div className="p-1">
                                                <strong>
                                                  Deliveryman Location
                                                </strong>
                                                <br />
                                                {selectedOrder.delivery_location
                                                  .address || ""}
                                              </div>
                                            </Popup>
                                          </Marker>
                                        </MapContainer>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}

            {/* Tracking Modal */}
            {showTrackingModal && trackingOrder && (
              <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg">
                  <div
                    className="modal-content"
                    style={{ borderRadius: "8px", border: "none" }}
                  >
                    <div
                      className="modal-header bg-white"
                      style={{
                        borderBottom: "1px solid #eee",
                        padding: "1rem 1.5rem",
                      }}
                    >
                      <h5 className="modal-title">
                        Track Order -{" "}
                        <span className="text-primary">{trackingOrder.id}</span>
                      </h5>
                      <button
                        type="button"
                        onClick={closeTrackingModal}
                        className="btn-close"
                        style={{ opacity: 0.5 }}
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body" style={{ padding: "1.5rem" }}>
                      {trackingOrder.delivery_location ? (
                        <div>
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <p>
                                <strong>Last Updated:</strong>{" "}
                                {new Date(
                                  trackingOrder.delivery_location.updated_at,
                                ).toLocaleString()}
                              </p>
                              <p>
                                <strong>Location:</strong>{" "}
                                {trackingOrder.delivery_location.address ||
                                  "Address not available"}
                              </p>
                              <p>
                                <strong>Deliveryman:</strong>{" "}
                                {trackingOrder.assigned_deliveryman?.name ||
                                  "Not assigned"}
                              </p>
                            </div>
                            <div className="col-md-6">
                              <p>
                                <strong>Order Status:</strong>{" "}
                                <span className="badge badge-primary">
                                  {trackingOrder.status}
                                </span>
                              </p>
                              <p>
                                <strong>Customer:</strong>{" "}
                                {trackingOrder.source === "sunrise-website"
                                  ? `${trackingOrder.shipping_address?.firstName} ${trackingOrder.shipping_address?.lastName}`
                                  : `${trackingOrder.shipping_address?.doctorName} - ${trackingOrder.shipping_address?.hospitalName}`}
                              </p>
                            </div>
                          </div>

                          {/* Map container */}
                          <div
                            className="map-container"
                            style={{
                              height: "400px",
                              width: "100%",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                            }}
                          >
                            {trackingOrder.delivery_location.latitude &&
                            trackingOrder.delivery_location.longitude ? (
                              <MapContainer
                                center={[
                                  parseFloat(
                                    trackingOrder.delivery_location.latitude,
                                  ),
                                  parseFloat(
                                    trackingOrder.delivery_location.longitude,
                                  ),
                                ]}
                                zoom={15}
                                style={{ height: "100%", width: "100%" }}
                              >
                                <TileLayer
                                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                />
                                <Marker
                                  position={[
                                    parseFloat(
                                      trackingOrder.delivery_location.latitude,
                                    ),
                                    parseFloat(
                                      trackingOrder.delivery_location.longitude,
                                    ),
                                  ]}
                                >
                                  <Popup>
                                    <strong>
                                      {trackingOrder.assigned_deliveryman
                                        ?.name || "Deliveryman"}
                                      's Location
                                    </strong>
                                    <br />
                                    {trackingOrder.delivery_location.address ||
                                      "Address not available"}
                                  </Popup>
                                </Marker>
                              </MapContainer>
                            ) : (
                              <div className="text-center p-5">
                                Waiting for location data...
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="alert alert-warning">
                          <p>
                            No tracking information available for this order.
                          </p>
                          <p>
                            Tracking information will be available once the
                            deliveryman starts the delivery.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
